/*
 * @Desc: 工具
 * @Author: zcc
 * @Date: 2022-11-07 10:15:13
 * @LastEditors: zcc
 * @LastEditTime: 2022-11-07 10:15:28
 */
const path = require('path')
// 全局引入组件 以文件名为组件名
export const globalComponents = (r, app) => {
  r.keys().forEach((item) => {
    const key = path.basename(item, path.extname(item))
    app.component(key, r(item).default)
  })
}

// 全局引入组件 以文件内部的Name为组件名
export const globalComponentsName = (r, app) => {
  r.keys().forEach((item) => {
    app.component(r(item).default.name, r(item).default)
  })
}
